import React, { useMemo } from 'react'
import { generatePath } from 'react-router-dom'
import { API_ROUTES } from 'app/components/AppRouter/routes'
import { readFileBlob, validateAppImageDimensions } from './fileUtils'
import { UserCategory } from '../../domain/User'

export const delay = (timeInMs: number) => {
    return new Promise(resolve => setTimeout(resolve, timeInMs))
}

export const onInputChange =
    (e: React.ChangeEvent<HTMLInputElement>) =>
    (dispatch: any, stateUpdate: any) => {
        const name = e.target.name
        const value =
            e.target.type === 'radio' || e.target.type === 'checkbox'
                ? e.target.checked
                : e.target.value
        dispatch(stateUpdate({ [name]: value }))
    }

export const onSelectChange =
    (e: React.ChangeEvent<HTMLSelectElement>) =>
    (dispatch: any, stateUpdate: any) => {
        const name = e.target.name
        const value = e.target.value
        dispatch(stateUpdate({ [name]: value }))
    }

export const onFileInputChange =
    (e: React.ChangeEvent<HTMLInputElement>) =>
    (dispatch: any, stateUpdate: any) => {
        const name = e.target.name
        const value = e.target.files && e.target.files[0]

        if (value) {
            readFileBlob(value).then(res => {
                dispatch(stateUpdate({ [name]: res }))
                return res
            })
            // TODO check dimensions of the image
            // .then(res => {
            //     validateAppImageDimensions(res).then(valid => {
            //         console.log('Image validation:', valid)
            //     })
            // })
            // TODO add catch route to Promise
        } else {
            // TODO show error notification
        }
    }

export const onImageInputChange =
    (e: React.ChangeEvent<HTMLInputElement>) =>
    (dispatch: any, stateUpdate: any) => {
        const name = e.target.name
        const value = e.target.files && e.target.files[0]

        if (value) {
            console.log('File:', value)
            readFileBlob(value).then(res => {
                dispatch(stateUpdate({ [name]: res }))
            })
            // TODO add catch route to Promise
        } else {
            // TODO show error notification
        }
    }

export const isTokenExpired = (): boolean => {
    const token = localStorage.getItem('token')

    if (!token) return true

    const expired = localStorage.getItem('tokenExpired')

    if (!expired) return true

    const nowDate = new Date()
    const expiredDate = new Date(Number.parseInt(expired))

    return expiredDate <= nowDate
}

export const makeDownloadApkLink = (appId: string, apkId: string): string => {
    return generatePath(API_ROUTES.DOWNLOAD_APK, { appid: appId, apkid: apkId })
}

export const setUserToken = (token: string, tokenExpired: number) => {
    localStorage.setItem('token', token)
    localStorage.setItem('tokenExpired', tokenExpired.toString())
}

export const isAdmin = (): boolean => {
    if (isTokenExpired()) return false
    const payload = getJwtPayload()
    return [UserCategory.EDITOR, UserCategory.ADMIN].includes(
        payload?.level as UserCategory)
}

const decodeBase64Url = (input: string): string => {
    const normalized = input.replace(/-/g, '+').replace(/_/g, '/')
    const pad = normalized.length % 4
    const padded = pad ? normalized + '='.repeat(4 - pad) : normalized
    return atob(padded)
}

const getJwtPayload = (): JwtPayload | null => {
    const token = localStorage.getItem('token')
    if (!token) return null

    const parts = token.split('.')
    if (parts.length < 2) return null

    try {
        return JSON.parse(decodeBase64Url(parts[1])) as JwtPayload
    } catch {
        return null
    }
}

type JwtPayload = {
    level?: number
    exp?: number
}

